module.exports = __webpack_public_path__ + "assets/img/step2-title.b473ef4d.svg";